import { useCallback } from "react";
import type { GridRowsProp, GridColDef } from "@mui/x-data-grid";
import { Paper } from "@mui/material";
import SbuxCard from "../../../components/SbuxCard";
import SbuxDataGrid from "../../../components/SbuxDataGrid";
import styles from "./styles";
import useCss from "../../../hooks/useCss";
import SbuxTranslate from "../../../components/SbuxTranslate";
import { CURRENT_TICKET_OR_CASE_NUMBER } from "../../../constants";

interface CurrentDataGridProps {
  rows: GridRowsProp;
  columns: Record<string, unknown>[];
}

const CurrentDataGrid = ({ rows, columns }: CurrentDataGridProps) => {
  const handleIsCellEditable = useCallback(
    (params: { row: unknown; field: string }) => {
      const row = params.row as { name?: string };
      return row.name === CURRENT_TICKET_OR_CASE_NUMBER;
    },
    [],
  );

  const getTranslatedColumns = (
    cols: Record<string, unknown>[],
  ): GridColDef[] => {
    return cols.map((column) => ({
      ...(column as unknown as GridColDef),
      renderHeader: () => (
        <Paper
          component="span"
          elevation={0}
          className="MuiDataGrid-columnHeaderTitle"
          sx={{ backgroundColor: "transparent" }}
        >
          <SbuxTranslate>{String(column.headerName ?? "")}</SbuxTranslate>
        </Paper>
      ),
    }));
  };

  const classes = useCss(styles);

  return (
    <div className={classes.gridWrapper}>
      <SbuxCard className="insideTabContainer">
        <SbuxDataGrid
          columns={getTranslatedColumns(columns)}
          rows={rows}
          handleEditRowsModelChange={() => undefined}
          handleIsCellEditable={handleIsCellEditable}
        />
      </SbuxCard>
    </div>
  );
};

export default CurrentDataGrid;
